var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.model)?_c(_vm.component,_vm._b({key:JSON.stringify(_vm.model),tag:"component"},'component',{ event: _vm.model },false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }